import React, { useState, useEffect } from 'react';
import Moment from 'moment';
import { Link, useHistory } from 'react-router-dom';
import { FiArrowLeftCircle, FiArrowRightCircle, FiSend } from 'react-icons/fi';
import { FaRegCommentAlt } from 'react-icons/fa';
import { AiFillLike, AiOutlineAppstoreAdd } from 'react-icons/ai';
import api from '../../services/api';
import Header from '../Includes/Header';
import NavNegociacoes from '../Includes/NavNegociacoes';
import TituloPagina from '../Includes/Titulos';
import Footer from '../Includes/Footer';
import FormData, { getHeaders } from 'form-data';
import trash from '../../assests/trash.png';
import { withTranslation } from "react-i18next";

import './styles.css';

class Negocio extends React.Component {

  constructor(props) {
    super(props);
    const tags = JSON.parse(sessionStorage.getItem('TAGS'));
    const cidades = [];

    api.get(`/v7/negotiations/${parseInt(props.match.params.id)}`, {
      headers: {
        'USER_EMAIL': sessionStorage.getItem('email'),
        'USER_TOKEN': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }
    }).then(response => {
      //console.log(response.data);
      response.data['tags'] = tags;
      response.data['frigorificos'] = [];
      response.data['cidades'] = cidades;
      if (!response.data['age_of_bovine']) {
        response.data['age_of_bovine'] = "zero_to_twelve";
      }
      response.data['bread'] = "";
      if (!response.data.fridge) {
        response.data['fridge_id'] = "";
        response.data['slaughter_house_name'] = "";
        response.data['fridge'] = { 'name': '' }
      } else {
        response.data['fridge_id'] = response.data.fridge.id;
        response.data['slaughter_house_name'] = response.data.fridge.name;
      }
      response.data['reviwer_id'] = 1;
      response.data['erros'] = [];
      if (!response.data['bovine_weight']) {
        response.data['bovine_weight'] = "";
      }
      response.data['userEmail'] = sessionStorage.getItem('email');
      response.data['userToken'] = sessionStorage.getItem('token');
      response.data['base_url'] = sessionStorage.getItem('BASE_URL');
      response.data['tag_id'] = response.data.tag.id;
      if (!response.data.slaughter_form) {
        response.data['slaughter_form'] = 'dead_weight';
      }
      if (!response.data.animals_quantity) {
        response.data['animalsQuantity'] = 0;
      }
      if (!response.data.date) {
        var data = new Date();
        response.data['date'] = data.getDate() + '/' + (data.getMonth() + 1) + '/' + data.getFullYear();
      }
      sessionStorage.setItem('slaughters', JSON.stringify(response.data.slaughters));

      this.setState(response.data)

    });
  }

  componentDidUpdate(prevState, prevProps) {
    // this.carregaTags(this.state.tag.id)
    if (prevState === prevProps) {
      return;
    }

    if (this.state.kind === 'sale') {
      document.getElementById('sale').checked = true;
    } else {
      document.getElementById('purchase').checked = true;
    }
    //DATA DA NEGOCIAÇÃO
    var dataFormatada = this.state.negotiation_date.replace(/(\d*)-(\d*)-(\d*).*/, '$1-$2-$3');
    document.getElementById('negotiation_date').value = dataFormatada;
    document.getElementById('frigorifico').value = this.state.fridge.name;
    if (this.state.slaughter_form === 'dead_weight') {
      document.getElementById('dead_weight').checked = true;
    } else {
      document.getElementById('live_weight').checked = true;
    }
    document.getElementById('negotiated_value').value = this.state.negotiated_value;
    this.carregaTags();
    this.carregaPayment_deadline();
    this.carregaTaxForm();
    this.carregaFreight_responsibility();
    //this.setState({ 'slaughters': JSON.parse(sessionStorage.getItem('slaughters')) });
    this.carregaAbate();
    document.getElementById('bovine_weight').value = this.state.bovine_weight;
    document.getElementById('animals_quantity').value = this.state.animals_quantity;
    document.getElementById('obs').value = this.state.notes;
    document.getElementById('age_of_bovine').value = this.state.age_of_bovine;
    //this.atualizaTagId();

  }

  apagaVetor(contador) {
    //let excluir = contador - 1;
    let excluir = contador;
    if (excluir < 0) {
      excluir = 0;
    }
    //this.state.slaughters(this.state.slaughters.splice(excluir, 1));
    var slaughters = this.state.slaughters.splice(excluir, 1);

    this.setState({ 'slaughters': slaughters });
    var elemento_pai = document.getElementById('listaAbates');
    elemento_pai.innerHTML = "";
    var titulo = '';
    var textoTitulo = '';
    var cont = 0;
    var qtde = "";
    var textoQtde = "";
    var dtAbate = "";
    var dt = "";
    var textoDtAbate = "";
    var aproveitamento = "";
    var apr = "";
    var txtAprov = "";
    var icone = "";

    this.state.slaughters.forEach(function (element, index) {

      //if ((cont + 1) === this.state.slaughters.length) {
      icone = document.createElement("p");
      icone.className = "clIcon";
      var image = new Image(25, 25);
      image.src = trash;
      image.alt = index;
      //image.onclick = () => this.apagaVetor(index);
      image.onclick = () => this.apagaVetor(index);

      icone.appendChild(image);
      //} else {
      //  icone = document.createElement("p");
      //}
      titulo = document.createElement('p');
      titulo.className = "tituloAbate";
      textoTitulo = document.createTextNode(this.props.t('pages.negotiationDetails.slaughter') + (index + 1));
      titulo.appendChild(textoTitulo);

      qtde = document.createElement('p');
      qtde.className = "qtdeAbate";
      textoQtde = document.createTextNode(this.props.t('pages.negotiationDetails.animalsQuantity') + element.animals_quantity);
      qtde.appendChild(textoQtde);

      dtAbate = document.createElement('p');
      dtAbate.className = "qtdeAbate";
      textoDtAbate = document.createTextNode(this.props.t('pages.negotiationDetails.animalsQuantity') + element.slaughter_date.replace(/(\d*)-(\d*)-(\d*).*/, '$3/$2/$1'));
      dtAbate.appendChild(textoDtAbate);

      aproveitamento = document.createElement('p');
      aproveitamento.className = "aproveitamento";
      txtAprov = document.createTextNode(this.props.t('pages.negotiationDetails.slaughterDate') + element.slaughter_yield);
      aproveitamento.appendChild(textoDtAbate);
      elemento_pai.appendChild(icone);
      elemento_pai.appendChild(titulo);
      elemento_pai.appendChild(qtde);
      elemento_pai.appendChild(aproveitamento);
      cont++;
    });
    if (this.state.slaughters.length === 0) {
      this.setState({
        'slaughters': []
      });
    }
  }

  addAbate() {
    var animalsQuantity = document.getElementById('animals_quantity2').value;
    var slaughter_date = document.getElementById('slaughter_date').value;
    var slaughter_yield = 0;
    if (animalsQuantity && slaughter_date) {
      this.state.slaughters.push({
        'animals_quantity': animalsQuantity,
        'slaughter_date': slaughter_date,
        'slaughter_yield': slaughter_yield,
      });
      var elemento_pai = document.getElementById('listaAbates');
      elemento_pai.innerHTML = "";
      var titulo = '';
      var textoTitulo = '';
      var cont = 0;
      var qtde = "";
      var textoQtde = "";
      var dtAbate = "";
      var dt = "";
      var textoDtAbate = "";
      var aproveitamento = "";
      var apr = "";
      var txtAprov = "";
      var icone = "";

      this.state.slaughters.forEach(function (element, index) {
        //if ((cont + 1) === this.state.slaughters.length) {
        icone = document.createElement("p");
        icone.className = "clIcon";
        var image = new Image(25, 25);
        image.src = trash;
        //image.onclick = () => this.apagaVetor(index);
        image.onclick = () => this.apagaVetor(index);
        image.alt = cont;
        icone.appendChild(image);
        //} else {
        //  icone = document.createElement("p");
        //}

        titulo = document.createElement('p');
        titulo.className = "tituloAbate";
        textoTitulo = document.createTextNode(this.props.t('pages.negotiationDetails.slaughter') + (index + 1));
        titulo.appendChild(textoTitulo);

        qtde = document.createElement('p');
        qtde.className = "qtdeAbate";
        textoQtde = document.createTextNode(this.props.t('pages.negotiationDetails.animalsQuantity') + element.animals_quantity);
        qtde.appendChild(textoQtde);

        dtAbate = document.createElement('p');
        dtAbate.className = "qtdeAbate";
        textoDtAbate = document.createTextNode(this.props.t('pages.negotiationDetails.animalsQuantity') + element.slaughter_date.replace(/(\d*)-(\d*)-(\d*).*/, '$3/$2/$1'));
        dtAbate.appendChild(textoDtAbate);

        aproveitamento = document.createElement('p');
        aproveitamento.className = "aproveitamento";
        txtAprov = document.createTextNode(this.props.t('pages.negotiationDetails.slaughterDate') + element.slaughter_yield);
        aproveitamento.appendChild(textoDtAbate);
        elemento_pai.appendChild(icone);
        elemento_pai.appendChild(titulo);
        elemento_pai.appendChild(qtde);
        elemento_pai.appendChild(aproveitamento);
        cont++;
      });
    }
  }



  carregaAbate() {
    //sessionStorage.setItem('slaughters',this.state.slaughters);
    var elemento_pai = document.getElementById('listaAbates');
    elemento_pai.innerHTML = "";
    var titulo = '';
    var textoTitulo = '';
    var cont = 0;
    var qtde = "";
    var textoQtde = "";
    var dtAbate = "";
    var dt = "";
    var textoDtAbate = "";
    var aproveitamento = "";
    var apr = "";
    var txtAprov = "";
    var icone = "";

    function apagaAbt(contador, slaug) {
      //this.setState({ 'slaughters': JSON.parse(sessionStorage.getItem('slaughters')) });
      //console.log(slaug);
      var novoVet = [];
      var nVet = [];

      var slaughters = JSON.parse(sessionStorage.getItem('slaughters'));
      slaughters.forEach(function (element, index) {
        //console.log(element)
        if (element.id !== slaug.id) {
          novoVet.push(element);
        }
      });
      novoVet.forEach(function (element, index) {
        nVet[index] = { "animals_quantity": element.animals_quantity };
        nVet[index] = { "slaughter_date": element.slaughter_date };
        nVet[index] = { "slaughter_yield": element.slaughter_yield };
      });

      //console.log(nVet);
      sessionStorage.setItem('slaughters', JSON.stringify(nVet));

      //this.state.slaughters(this.state.slaughters.splice(excluir, 1));
      //var slaughters = this.state.slaughters.splice(excluir, 1);
      var elemento_pai = document.getElementById('listaAbates');
      elemento_pai.innerHTML = "";
      var titulo = '';
      var textoTitulo = '';
      var cont = 0;
      var qtde = "";
      var textoQtde = "";
      var dtAbate = "";
      var dt = "";
      var textoDtAbate = "";
      var aproveitamento = "";
      var apr = "";
      var txtAprov = "";
      var icone = "";
      novoVet.forEach(function (element, index) {
        //if ((cont + 1) === this.state.slaughters.length) {
        icone = document.createElement("p");
        icone.className = "clIcon";
        var image = new Image(25, 25);
        image.src = trash;
        //image.onclick = () => this.apagaVetor(index);
        image.onclick = () => apagaAbt(index, element);
        image.alt = index;
        icone.appendChild(image);
        //} else {
        //  icone = document.createElement("p");
        //}

        titulo = document.createElement('p');
        titulo.className = "tituloAbate";
        textoTitulo = document.createTextNode(this.props.t('pages.negotiationDetails.slaughter') + (index + 1));
        titulo.appendChild(textoTitulo);

        qtde = document.createElement('p');
        qtde.className = "qtdeAbate";
        textoQtde = document.createTextNode(this.props.t('pages.negotiationDetails.animalsQuantity') + element.animals_quantity);
        qtde.appendChild(textoQtde);

        dtAbate = document.createElement('p');
        dtAbate.className = "qtdeAbate";
        textoDtAbate = document.createTextNode(this.props.t('pages.negotiationDetails.animalsQuantity') + element.slaughter_date.replace(/(\d*)-(\d*)-(\d*).*/, '$3/$2/$1'));
        dtAbate.appendChild(textoDtAbate);

        aproveitamento = document.createElement('p');
        aproveitamento.className = "aproveitamento";
        txtAprov = document.createTextNode(this.props.t('pages.negotiationDetails.slaughterDate') + element.slaughter_yield);
        aproveitamento.appendChild(textoDtAbate);
        elemento_pai.appendChild(icone);
        elemento_pai.appendChild(titulo);
        elemento_pai.appendChild(qtde);
        elemento_pai.appendChild(aproveitamento);
        cont++;
      });
    }

    this.state.slaughters.forEach(function (element, index) {
      //if ((cont + 1) === this.state.slaughters.length) {
      icone = document.createElement("p");
      icone.className = "clIcon";
      var image = new Image(25, 25);
      image.src = trash;
      //image.onclick = () => this.apagaVetor(index);
      image.onclick = () => apagaAbt(index, element);
      image.alt = index;
      icone.appendChild(image);
      //} else {
      //  icone = document.createElement("p");
      //}

      titulo = document.createElement('p');
      titulo.className = "tituloAbate";
      textoTitulo = document.createTextNode(this.props.t('pages.negotiationDetails.slaughter') + (index + 1));
      titulo.appendChild(textoTitulo);

      qtde = document.createElement('p');
      qtde.className = "qtdeAbate";
      textoQtde = document.createTextNode(this.props.t('pages.negotiationDetails.animalsQuantity') + element.animals_quantity);
      qtde.appendChild(textoQtde);

      dtAbate = document.createElement('p');
      dtAbate.className = "qtdeAbate";
      textoDtAbate = document.createTextNode(this.props.t('pages.negotiationDetails.animalsQuantity') + element.slaughter_date.replace(/(\d*)-(\d*)-(\d*).*/, '$3/$2/$1'));
      dtAbate.appendChild(textoDtAbate);

      aproveitamento = document.createElement('p');
      aproveitamento.className = "aproveitamento";
      txtAprov = document.createTextNode(this.props.t('pages.negotiationDetails.slaughterDate') + element.slaughter_yield);
      aproveitamento.appendChild(textoDtAbate);
      elemento_pai.appendChild(icone);
      elemento_pai.appendChild(titulo);
      elemento_pai.appendChild(qtde);
      elemento_pai.appendChild(aproveitamento);
      cont++;
    });
  }

  handleInputChangeKind(event) {
    this.setState({
      'kind': event
    })
  }

  handleInputSlaughter_form(event) {
    this.setState({
      'slaughter_form': event
    })
  }


  pegarInputData() {
    return this.state.negotiation_date;
  }

  abreTags(e) {
    this.setState({
      'tag': {
        'id': (e.target.value)
      }
    });
    this.setState({
      'tag_id': e.target.value
    })
    this.state.tags.forEach(tag => {
      let i = 0;
      if (parseInt(tag.id) === parseInt(e.target.value)) {
        const isBovine = document.querySelectorAll(".is_bovine");
        if (tag.is_bovine === true) {
          var titData = document.getElementById('titData');
          var campoData = document.getElementById('campoData');
          titData.classList.remove('hidden');
          //console.log(titData);
          campoData.classList.remove('hidden');          
          for (i = 0; i < isBovine.length; i++) {
            isBovine.item(i).classList.remove('hidden');
          }
          const isSlaughter = document.querySelectorAll(".is_slaughter");
          if (tag.is_slaughter === false) {
            //setAge_of_bovine('zero_to_twelve');
            for (i = 0; i < isSlaughter.length; i++) {
              isSlaughter.item(i).classList.remove('hidden');
            }
            for (i = 0; i < isBovine.length; i++) {
              isBovine.item(i).classList.add('hidden');
            }
          } else {
            for (i = 0; i < isSlaughter.length; i++) {
              isSlaughter.item(i).classList.add('hidden');
            }
          }
        } else {
          for (i = 0; i < isBovine.length; i++) {
            isBovine.item(i).classList.add('hidden');
          }
        }
      }
    });
  }

  async SelectFrigorifico(frig) {
    if (frig.length >= 3) {
      await api.get(`/v5/fridges/optimized_index?by_name=${frig}`, {
        headers: {
          'USER_EMAIL': sessionStorage.getItem('email'),
          'USER_TOKEN': sessionStorage.getItem('token'),
        }
      }).then(response => {
        var vFrig = response.data;
        this.setState({
          'frigorificos': vFrig
        });
        document.getElementById("dvFrigorificos").style.display = "block";
      }).catch(function (response) {
      });
    }
  }

  meuFrig(nome, id) {
    this.setState({
      'slaughter_house_name': nome,
      'fridge_id': id,
    })
    this.setState({
      'fridge': { 'name': nome }
    });
    //response.data['slaughter_house_name'] = response.data.fridge.name;

    // this.setState({
    //   'fridge': {
    //     'id': id,
    //     'name': nome
    //   }
    // })
    document.getElementById("dvFrigorificos").style.display = "none";
    document.getElementById("frigorifico").value = nome;
  }

  handleSelectPayment_measure(e) {
    this.setState({
      'payment_measure': e
    })
  }

  handlePayment_deadline(e) {
    var diasPag = document.getElementById('diasPag');
    if (e === "vista") {
      diasPag.value = 0;
      diasPag.style.display = 'none';
      this.setState({
        'payment_deadline': 0
      })
    } else {
      diasPag.style.display = 'block';
    }
  }

  handlePayment_deadlineValor(e) {
    this.setState({
      'payment_deadline': e
    })
  }

  carregaPayment_deadline() {
    var pay = document.getElementById('nroDias');
    var diasPag = document.getElementById('diasPag');
    var vista = document.getElementById('vista');
    var prazo = document.getElementById('prazo');
    if (this.state.payment_deadline > 0) {
      diasPag.style.display = 'block';
      pay.value = this.state.payment_deadline;
      prazo.checked = true;
    } else {
      diasPag.style.display = 'none';
      pay.value = "0";
      vista.checked = true;
    }
  }
  carregaTaxForm() {
    var toCharge = document.getElementById('to_charge');
    var free = document.getElementById('free');
    var free_taxes = document.getElementById('free_taxes');
    var tax_form = this.state.tax_form;
    if (tax_form === 'to_charge') {
      toCharge.checked = 'true';
    } else if (tax_form === 'free') {
      free.checked = 'true';
    } else {
      free_taxes.checked = 'true';
    }
  }

  carregaFreight_responsibility() {
    var buyer = document.getElementById('buyer');
    var seller = document.getElementById('seller');
    if (this.state.freight_responsibility === 'buyer') {
      buyer.checked = 'true';
    } else {
      seller.checked = 'true';
    }
  }

  atualizaTagId(id) {
    this.setState({
      'tag_id': id
    })
  }

  carregaTags() {
    this.state.tags.forEach(tag => {
      let i = 0;
      if (parseInt(tag.id) === this.state.tag.id) {
        //this.atualizaTagId(tag.id);
        const isBovine = document.querySelectorAll(".is_bovine");
        if (tag.is_bovine === true) {
          var titData = document.getElementById('titData');
          var campoData = document.getElementById('campoData');
          titData.classList.remove('hidden');
          //console.log(titData);
          campoData.classList.remove('hidden');          
          for (i = 0; i < isBovine.length; i++) {
            isBovine.item(i).classList.remove('hidden');
          }
          const isSlaughter = document.querySelectorAll(".is_slaughter");
          if (tag.is_slaughter === false) {
            //setAge_of_bovine('zero_to_twelve');
            for (i = 0; i < isSlaughter.length; i++) {
              isSlaughter.item(i).classList.remove('hidden');
            }
            for (i = 0; i < isBovine.length; i++) {
              isBovine.item(i).classList.add('hidden');
            }
          } else {
            for (i = 0; i < isSlaughter.length; i++) {
              isSlaughter.item(i).classList.add('hidden');
            }
          }
        } else {
          for (i = 0; i < isBovine.length; i++) {
            isBovine.item(i).classList.add('hidden');
          }
        }
      }
    });
  }

  handleTax_form(e) {
    this.setState({
      'tax_form': e
    })
  }

  handleFreight_responsibility(e) {
    var buyer = document.getElementById('buyer');
    var seller = document.getElementById('seller');

    this.setState({
      'freight_responsibility': e
    })
    if (e === 'buyer') {
      buyer.checked = 'true';
    } else {
      seller.checked = 'true';
    }
  }

  handleSelectAge_of_bovine(e) {
    this.setState({
      'age_of_bovine': e
    })
  }

  minhaCidade(id, nome, code) {
    this.setState({
      'city': {
        'id': id,
        'name': nome.substr(0, (nome.length - 4)),
        'code': code,
      }
    })
    document.getElementById("dvCidades").style.display = "none";
  }

  async SelectCidade(city) {
    let data = new FormData();
    if (city.length >= 3) {
      const response = await api.get(`/v4/search/cities?term=${city}`, {
        headers: {
          ...data.getHeaders
        }
      }, data);
      this.setState({
        'cidades': response.data
      })
      document.getElementById("dvCidades").style.display = "block";

    }
  }

  handleNote(e) {
    this.setState({
      'notes': e
    })
  }

  mostrarSuccess() {
    let msg = document.getElementById('success');
    msg.style.display = 'block';
    let btn = document.getElementById('btn-enviar');
    btn.disabled = true;

    setTimeout(() => {
      msg.style.display = 'none';
      //history.push('/negociacoes')
    }, 10000)
  }
  mostrarErros() {
    let msg = document.getElementById('msg');
    msg.style.display = 'block';
    setTimeout(() => {
      msg.style.display = 'none';
    }, 5000)
  }


  alterarNegocio(event, dados) {
    //const history = useHistory();

    dados.slaughters = JSON.parse(sessionStorage.getItem('slaughters'));

    //console.log(dados.slaughters);
    event.preventDefault();
    const data = {
      kind: dados.kind,
      slaughter_form: dados.slaughter_form,
      tax_form: dados.tax_form,
      payment_form: "in_installment",
      freight_responsibility: dados.freight_responsibility,
      date: dados.date,
      bread: dados.bread,
      bovine_weigth: dados.bovine_weigth,
      negotiated_value: dados.negotiated_value,
      tag_id: dados.tag_id,
      user_id: dados.user.id,
      created_at: dados.negotiation_date,
      updated_at: dados.negotiation_date,
      payment_deadline: (dados.payment_deadline === null) ? 0 : dados.payment_deadline,
      slaughter_house_name: dados.slaughter_house_name,
      payment_measure: dados.payment_measure,
      city_code: dados.city.code,
      age_of_bovine: dados.age_of_bovine,
      negotiation_date: dados.negotiation_date,
      animals_quantity: dados.animals_quantity,
      fridge_id: dados.fridge_id,
      notes: dados.notes,
      //slaughters: dados.slaughters,
      slaughters: dados.slaughters,
      reviwer_id: dados.reviwer.id,
      reviwer: dados.reviwer,
    }

    //console.log(data);

    const negociacao_id = this.state.id;
    var axios = require('axios');
    var config = {
      method: 'put',
      url: dados.base_url + `/v4/users/me/negotiations/${this.state.id}`,
      headers: {
        'USER_TOKEN': dados.userToken,
        'USER_EMAIL': dados.userEmail,
        'Content-Type': 'application/json'
      },
      data: data
    };
    axios(config, negociacao_id)
      .then(function (response) {
        //this.mostrarSuccess();
        let msg = document.getElementById('success');
        msg.style.display = 'block';
        let btn = document.getElementById('btn-enviar');
        btn.disabled = true;
        //console.log(response.data);
        setTimeout(() => {
          msg.style.display = 'none';
          //dados.history.push(`/negociacoes/${negociacao_id}`)
          window.location = `/?negocio/informacao/${negociacao_id}`;
        }, 5000);
        dados['erros'] = [];
      }).catch(function (error) {
        //setErros(error.response.data.errors);
        if (!error.response.data.errors) {
          dados['erros'] = []
        } else {
          dados['erros'] = error.response.data.errors;
        }
        // MOSTRAR ERROS
        let msg = document.getElementById('msg');
        msg.style.display = 'block';
        setTimeout(() => {
          msg.style.display = 'none';
        }, 5000)
        // MOSTRAR ERROS

      });
  };

  desativarForm(event) {
    event.preventDefault();
  }

  handleNegotiated_value(e) {
    this.setState({
      'negotiated_value': e
    })
    return e.value;
  }



  show() {
    const y = document.getElementById('diasPag')
    y.style.display = 'block'
  }

  handleBread(e) {
    this.setState({
      'bread': e
    })
  }

  handleBovine_weight(e) {
    this.setState({
      'bovine_weight': e
    })
  }

  handleAnimals_quantity(e) {
    this.setState({
      'animals_quantity': e
    })
  }

  handleNegotiation_date(e){
    this.setState({
      'negotiation_date': e.value
    })
    return e.value;
  }

  handleInputData(e) {
    this.setState({
      'date': e.value
    })
    return e.value;
  }


  render() {
    if (!this.state) {
      return (
        <div className="negocio-container">
          <div className="negocio-container">
            <Header />
            <NavNegociacoes />
            <TituloPagina titulo={ this.props.t('pages.negotiationDetails.title') } />
            <section className="body">
              <ul>
                <li>
                  <div className="clCarregando"> { this.props.t('pages.negotiationDetails.loading') }</div>
                </li>
              </ul>
            </section>
          </div>
          <Footer />
        </div>

      );
    } else {
      return (
        <div className="negocio-container">
          <Header />
          <NavNegociacoes />
          <TituloPagina titulo={ this.props.t('pages.negotiationDetails.title') } />
          <section className="body">
            <ul>
              <li>
                <form className="formNegocio" onSubmit={e => this.alterarNegocio(e, this.state)}>
                  <div className="titulo">
                  { this.props.t('pages.negotiationDetails.buyOrSell') }
                </div>
                  <div className="campos">
                    <input type="radio" id="sale" name="tipo" value="sale"
                      onChange={e => this.handleInputChangeKind(e.target.value)}
                    />
                    <label for="sale"> { this.props.t('pages.negotiationDetails.buy') } </label>
                    <input type="radio" id="purchase" name="tipo" value="purchase"
                      onChange={e => this.handleInputChangeKind(e.target.value)}
                    />
                    <label for="purchase"> { this.props.t('pages.negotiationDetails.sell') } </label>
                  </div>
                  <div className="titulo">
                    { this.props.t('pages.negotiationDetails.negotiationDate') }
                </div>
                  <div className="campos">
                    <input id="negotiation_date" type="date"
                      onChange={e => this.handleNegotiation_date(e.target)}
                      value={Moment(this.state.negotiation_date).format('YYYY-MM-DD')}
                    />
                  </div>
                  <div className="titulo">
                    { this.props.t('pages.negotiationDetails.tags') }
                </div>
                  <div className="campos">
                    <select id="tag_id"
                      value={this.state.tag.id}
                      onChange={e => this.abreTags(e)}
                    >
                      <option value="0"> { this.props.t('pages.negotiationDetails.labels.selectTag') } </option>
                      {
                        this.state.tags.map(row =>
                          <option value={row.id} key={row.id}>{row.name}</option>
                        )
                      }
                    </select>
                  </div>
                  <div className="campos is_bovine hidden">
                    <input
                      placeholder={ this.props.t('pages.negotiationDetails.placeholders.fridge') }
                      onKeyUp={e => this.SelectFrigorifico(e.target.value)}
                      type="text" name="frigorificos" id="frigorifico"
                      //value={this.state.fridge.name}
                      onChange={e => (e.target.value)}
                    />
                  </div>
                  <div className="frigorificos" id="dvFrigorificos">
                    {
                      this.state.frigorificos.map(frig => (
                        <div>
                          <Link onClick={() => this.meuFrig(frig.name, frig.id)}>{frig.name}</Link>
                        </div>
                      ))
                    }
                  </div>
                  <div className="titulo is_bovine hidden">
                    { this.props.t('pages.negotiationDetails.slaughterForm') }
                </div>
                  <div className="campos is_bovine hidden">
                    <input type="radio" id="dead_weight" name="slaughter_form" value="dead_weight"
                      onChange={e => this.handleInputSlaughter_form(e.target.value)}
                    />
                    <label for="sale"> { this.props.t('pages.negotiationDetails.labels.dead_weight') } </label>
                    <input type="radio" id="live_weight" name="slaughter_form" value="live_weight"
                      onChange={e => this.handleInputSlaughter_form(e.target.value)}
                    />
                    <label for="purchase"> { this.props.t('pages.negotiationDetails.labels.live_weight') } </label>
                  </div>

                  <div className="campos50">
                    <input type="text" placeholder={ this.props.t('pages.negotiationDetails.placeholders.values') }
                      id="negotiated_value"
                      onKeyUp={e => this.handleNegotiated_value(e.target.value)}
                      onChange=""
                    />
                    <select name="payment_measure" id="payment_measure"
                      value={this.state.payment_measure}
                      onChange={e => this.handleSelectPayment_measure(e.target.value)}
                    >
                      <option value="fifteen_kilos"> { this.props.t('pages.negotiationDetails.options.paymentMeasure.fifteenKilos') } </option>
                      <option value="sacs"> { this.props.t('pages.negotiationDetails.options.paymentMeasure.sacs') } </option>
                      <option value="tons"> { this.props.t('pages.negotiationDetails.options.paymentMeasure.tons') } </option>
                      <option value="head"> { this.props.t('pages.negotiationDetails.options.paymentMeasure.head') } </option>
                    </select>
                  </div>
                  <div id="titData" className="titulo is_slaugther hidden">
                  { this.props.t('pages.negotiationDetails.deliveryDate') }
                </div>
                  <div id="campoData" className="campos is_slaugther hidden">
                    <input id="date" type="date"
                      onChange={e => this.handleInputData(e.target)}
                      value={Moment(this.state.date).format('YYYY-MM-DD')}
                    />                    
                  </div>
                  <div className="titulo is_slaughter hidden">
                  { this.props.t('pages.negotiationDetails.bovineAge') }
                </div>
                  <div className="campos is_slaughter hidden">
                    <select name="age_of_bovine" id="age_of_bovine"
                      value={this.state.age_of_bovine}
                      onChange={e => this.handleSelectAge_of_bovine(e.target.value)}

                    >
                      <option value="zero_to_twelve" selected="selected"> { this.props.t('pages.negotiationDetails.options.bovineAge.zeroToTwelve') } </option>
                      <option value="twelve_to_eighteen"> { this.props.t('pages.negotiationDetails.options.bovineAge.twelveToEighteen') } </option>
                      <option value="eighteen_to_twenty"> { this.props.t('pages.negotiationDetails.options.bovineAge.eighteenToTwentyFour') } </option>
                      <option value="twenty_four_to_thirty_six"> { this.props.t('pages.negotiationDetails.options.bovineAge.twentyFourToThirtySix') } </option>
                      <option value="over_thirty_six"> { this.props.t('pages.negotiationDetails.options.bovineAge.aboveThirtySix') } </option>
                    </select>
                  </div>
                  <div className="titulo is_slaughter hidden">
                  { this.props.t('pages.negotiationDetails.breed') }
                </div>
                  <div className="campos is_slaughter hidden">
                    <input type="text"
                      value={this.state.bread}
                      onChange={e => this.handleBread(e.target.value)}
                    />
                  </div>
                  <div className="titulo is_slaughter hidden">
                    { this.props.t('pages.negotiationDetails.weight') }
                </div>
                  <div className="campos is_slaughter hidden">
                    <input type="number" id="bovine_weight"
                      value={this.state.bovine_weight}
                      onChange={e => this.handleBovine_weight(e.target.value)}
                    />
                  </div>
                  <div className="titulo is_slaughter hidden">
                    { this.props.t('pages.negotiationDetails.bovineQuantity') }
                </div>
                  <div className="campos is_slaughter hidden">
                    <input type="number" id="animals_quantity"
                      value={this.state.animals_quantity}
                      onChange={e => this.handleAnimals_quantity(e.target.value)}
                    />
                  </div>
                  <div className="titulo">
                    { this.props.t('pages.negotiationDetails.paymentForm') }
                </div>
                  <div className="campos">
                    <input type="radio" id="vista" name="forma" value="vista"
                      onChange={e => this.handlePayment_deadline(e.target.value)}
                      onclick={e => this.handlePayment_deadline(e.target.value)}
                    />
                    <label for="vista"> { this.props.t('pages.negotiationDetails.labels.paymentForm.in_cash') } </label>
                    <input type="radio" id="prazo" name="forma" value="prazo"
                      onChange={e => this.handlePayment_deadline(e.target.value)}
                      onclick={() => this.show}
                    />
                    <label for="prazo"> { this.props.t('pages.negotiationDetails.labels.paymentForm.in_installment') } </label>
                  </div>
                  <div id="diasPag" className="campos" style={{ 'display': 'none' }}>
                    <input type="number" placeholder={ this.props.t('pages.negotiationDetails.placeholders.paymentDeadline') } id="nroDias"
                      onKeyUp={e => this.handlePayment_deadlineValor(e.target.value)}
                      onChange={e => this.handlePayment_deadlineValor(e.target.value)}
                    />
                  </div>
                  <div className="titulo">
                    { this.props.t('pages.negotiationDetails.tax') }
                </div>
                  <div className="campos">
                    <input type="radio" id="to_charge" name="tax_form" value="to_charge"
                      onChange={e => this.handleTax_form(e.target.value)}
                    />
                    <label for="male"> { this.props.t('pages.negotiationDetails.labels.taxForm.to_charge') } </label>
                    <input type="radio" id="free" name="tax_form" value="free"
                      onChange={e => this.handleTax_form(e.target.value)}
                    />
                    <label for="female"> { this.props.t('pages.negotiationDetails.labels.taxForm.free') } </label>
                    <input type="radio" id="free_taxes" name="tax_form" value="free_taxes"
                      onChange={e => this.handleTax_form(e.target.value)}
                    />
                    <label for="female"> { this.props.t('pages.negotiationDetails.labels.taxForm.free_taxes') } </label>
                  </div>
                  <div className="titulo">
                  { this.props.t('pages.negotiationDetails.freight') }
                </div>
                  <div className="campos">
                    <input type="radio" id="buyer" name="freight_responsibility" value="buyer"
                      onClick={e => this.handleFreight_responsibility(e.target.value)}
                    />
                    <label for="male"> { this.props.t('pages.negotiationDetails.labels.freight.buyer') } </label>
                    <input type="radio" id="seller" name="freight_responsibility" value="seller"
                      onClick={e => this.handleFreight_responsibility(e.target.value)}
                    />
                    <label for="female"> { this.props.t('pages.negotiationDetails.labels.freight.seller') } </label>
                  </div>
                  <div className="titulo">
                    { this.props.t('pages.negotiationDetails.city') }
                </div>
                  <div className="campos">
                    <input
                      value=""
                      onChange=""
                      id="city_id"
                      className="city_id"
                      name="city_id"
                      type="hidden"
                    />
                    <input
                      placeholder={ this.props.t('pages.negotiationDetails.placeholders.city') }
                      onKeyUp={e => this.SelectCidade(e.target.value)}
                      type="text" name="cidade" id="cidade"
                      value={this.state.city.name}
                      onChange={e => (e.target.value)}
                      autocomplete="off"
                    />

                  </div>
                  <div className="cidades" id="dvCidades">
                    {
                      this.state.cidades.map(cid => (
                        <div>
                          <Link onClick={() => this.minhaCidade(cid.id, cid.value, cid.code)}>{cid.value}</Link>
                        </div>
                      ))
                    }
                  </div>
                  <div className="campos">
                    <input
                      type="text"
                      // value={this.state.note}
                      placeholder={ this.props.t('pages.negotiationDetails.placeholders.observation') }
                      id="obs"
                      onKeyUp={e => this.handleNote(e.target.value)}
                    />
                  </div>
                  <div className="titulo is_bovine hidden">
                    { this.props.t('pages.negotiationDetails.bovineSlaughterQuantity') }
                </div>
                  <div className="campos is_bovine hidden">
                    <input id="animals_quantity2" type="number" />
                  </div>
                  <div className="titulo is_bovine hidden">
                    { this.props.t('pages.negotiationDetails.slaughterDate') }
                </div>
                  <div className="campos is_bovine hidden">
                    <input id="slaughter_date" type="date" />
                    <span id="btn-abate" onClick={() => this.addAbate()}><AiOutlineAppstoreAdd /><span> { this.props.t('pages.negotiationDetails.buttons.addSlaughter') } </span></span>
                  </div>
                  <div id="listaAbates" className="is_bovine hidden">

                  </div>
                  <div className="success" id="success">
                    <p><strong> { this.props.t('pages.negotiationDetails.messages.success') } </strong></p>
                  </div>
                  <div className="alert" id="msg">
                    <p><strong> { this.props.t('pages.negotiationDetails.messages.invalidData') } </strong></p>
                    {this.state.erros.map(err => (
                      <p>- {err}</p>
                    ))}
                  </div>
                  <div className="campos">
                    <button className="btn-enviar" id="btn-enviar" type="submit"> { this.props.t('pages.negotiationDetails.buttons.send') } </button>
                  </div>
                </form>
              </li>
            </ul>
          </section>
          <Footer />
        </div>
      )
    }
  }
}

export default withTranslation()(Negocio);
